import { styled } from "../../../../../../styles";

export const OptionsBarContainer = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  gap: "7px",
  marginLeft: "14px",
});
